<p-panel>
  <div class="d-flex align-content-center"
       [ngClass]="{ 'justify-content-between': env.activateREA, 'justify-content-left': !env.activateREA }">

    <div>
      @if (flag === 'edit') {
        <h4>{{ headerTitleWhenEdit }}</h4>
      } @else {
        <h4>{{ headerTitleWhenNew }}</h4>
      }
    </div>

    <div>
      @if (env.activateREA) {
        <button
          class="btn bg-primary text-white bg-gradient text-black rea-btn mx-4 border-0 fw-bold"
          id="export-rea"
          (click)="form.showDialogExportREA = true"
          [disabled]="isReaDisabled">
          <i class="fa fa-download"></i>
          Importar REA
        </button>
      }
    </div>
  </div>

  <div class="row">
    <app-reactive-form-builder
      #formbuilder
      (formChanges)="formChanges($event[0], $event[1])"
      (goBack)="goBack()"
      (afterSend)="undefined"
      [form]="form.formFields"
      [serverUrl]="''"
      [dropdownLoadTrigger]="dropdownLoadTrigger"
      [dropdownsFinalized]="dropdownsFinalized"
      [id]="getModel().id"
      [request]="getType() === FormRequestTypes.EDIT ? fincasApi.fincasPUT : fincasApi.fincasPOST"
      [getRequest]="fincasApi.fincasGET">
    </app-reactive-form-builder>
  </div>
</p-panel>

@if (form.showDialogExportREA) {
  <app-rea-import-modal
    [(visible)]="form.showDialogExportREA"
    [model]="{
      codigo_REA: form.model.codigo_REA ?? null,
      titular_nif: form.model.nif ?? form.model.titular_nif ?? null,
      nombre_finca: form.model.nombre,
      id_cliente: form.model.id_cliente.id ?? null
    }"
    [historicoREA]="historicoREA"
    (imported)="onReaImported($event)">
  </app-rea-import-modal>
}